// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'desktop';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.813 17.438H6.186l.563-3.375h4.5zm-7.313 0h9M.563 11.063h16.875' />
    <path d='M15.188.563H2.812a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h12.376a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25z' />
  </g>
);

export const viewBox = '0 0 18 18';
